import { centsToInput, parseMoney } from '@closetly/core';
import { useState } from 'react';
import { useToast } from '../lib/toast';
import { Sheet } from './Sheet';

interface Props {
  budgetCents: number;
  onSave: (cents: number) => void;
  onClose: () => void;
}

export function BudgetSheet({ budgetCents, onSave, onClose }: Props) {
  const [value, setValue] = useState(() => centsToInput(budgetCents));
  const toast = useToast();

  function submit() {
    const cents = parseMoney(value);
    if (Number.isNaN(cents)) {
      toast('Gib eine Zahl ein, z. B. 300.');
      return;
    }
    onSave(cents ?? 0);
  }

  return (
    <Sheet open onClose={onClose} onSubmit={submit} labelledBy="budgetTitle">
      <h2 id="budgetTitle">Budget festlegen</h2>
      <p className="hint">
        Wie viel willst du insgesamt für Klamotten ausgeben? Leer lassen, um das Budget zu entfernen.
      </p>
      <div className="field">
        <label htmlFor="b-amount">Budget (€)</label>
        <input
          id="b-amount"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          inputMode="decimal"
          placeholder="300"
          autoComplete="off"
          data-autofocus
        />
      </div>
      <div className="sheet-actions">
        <div className="right">
          <button type="button" className="btn" onClick={onClose}>
            Abbrechen
          </button>
          <button type="submit" className="btn ink">
            Speichern
          </button>
        </div>
      </div>
    </Sheet>
  );
}
